import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import {
  AreaFilterCondition,
  CombinedCondition,
  FilterCondition,
  LegacyCombinedCondition,
  LegacyFilterCondition,
  LegacySimpleCondition,
  PartialFilterModelUtil,
  SimpleCondition,
} from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import {
  PlatformCombinedCondition,
  PlatformFilterCondition,
  PlatformSimpleCondition,
} from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

export const isLegacyCombinedCondition = (
  condition: LegacyFilterCondition
): condition is LegacyCombinedCondition => "conditions" in condition;

export const isCombinedCondition = (
  condition: PartialFilterModelUtil<FilterCondition>
): condition is CombinedCondition => "conditions" in condition;

export const isLegacySimpleCondition = (
  condition: LegacyFilterCondition
): condition is LegacySimpleCondition => !isLegacyCombinedCondition(condition);

export const isSimpleCondition = (
  condition: PartialFilterModelUtil<FilterCondition>
): condition is SimpleCondition =>
  !isCombinedCondition(condition) && "fieldFilterName" in condition;

export const isCombinedPlatformCondition = (
  condition: PlatformFilterCondition
): condition is PlatformCombinedCondition => "$and" in condition || "$or" in condition;

export const isAndPlatformCondition = (
  condition: PlatformFilterCondition
): condition is Required<Pick<PlatformCombinedCondition, "$and">> => "$and" in condition;

export const isOrPlatformCondition = (
  condition: PlatformFilterCondition
): condition is Required<Pick<PlatformCombinedCondition, "$or">> => "$or" in condition;

export const isSimplePlatformCondition = (
  condition: PlatformFilterCondition
): condition is PlatformSimpleCondition => !isCombinedPlatformCondition(condition);

export const isAreaFilterCondition = (
  condition: LegacySimpleCondition
): condition is AreaFilterCondition =>
  condition &&
  condition.operator === FilterOperator.IN_AREA &&
  condition.value &&
  typeof condition.value === "object" &&
  (("latitude" in condition.value &&
    "longitude" in condition.value &&
    "distanceInMeters" in condition.value) ||
    ("distanceInMeters" in condition.value && "entity" in condition.value));
